import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import { App } from "./App";
import logo from "url:./favicon.ico";

import PrCF_1 from "url:./assets/HelloWorldIcon.png";
import PrCF_2 from "url:./assets/InteractiveCVIcon.svg";
import PrCF_3 from "url:./assets/logo-3D.svg";
import PrCF_4 from "url:./assets/Icon_pdf_file.svg";
import PrCF_5 from "url:./assets/justice.svg";
import PrCF_6 from "url:./assets/Icon_photo_gallery.svg";
import PrCF_7 from "url:./assets/newtab.svg";
import PrCF_8 from "url:./components/System/OS/background.jpg";
import PrCF_9 from "url:./components/System/TaskBar/all_apps.svg";

import PoCF_1 from "url:./assets/glasgow_m1.pdf";
import PoCF_2 from "url:./assets/render.png";
import PoCF_3 from "url:./assets/researchlab_m1.pdf";
import PoCF_4 from "url:./components/Applications/PhotoGallery/assets/photography/1.jpg";
import PoCF_5 from "url:./components/Applications/PhotoGallery/assets/photography/2.jpg";
import PoCF_6 from "url:./components/Applications/PhotoGallery/assets/photography/3.jpg";
import PoCF_7 from "url:./components/Applications/PhotoGallery/assets/photography/4.jpg";
import PoCF_8 from "url:./components/Applications/PhotoGallery/assets/photography/5.jpg";
import PoCF_9 from "url:./components/Applications/PhotoGallery/assets/photography/6.jpg";
import PoCF_10 from "url:./components/Applications/PhotoGallery/assets/photography/7.jpg";
import PoCF_11 from "url:./components/Applications/PhotoGallery/assets/photography/8.jpg";
import PoCF_12 from "url:./components/Applications/PhotoGallery/assets/photography/9.jpg";
import PoCF_13 from "url:./components/Applications/PhotoGallery/assets/photography/10.jpg";
import PoCF_14 from "url:./components/Applications/PhotoGallery/assets/photography/11.jpg";
import PoCF_15 from "url:./components/Applications/PhotoGallery/assets/photography/12.jpg";
import PoCF_16 from "url:./components/Applications/PhotoGallery/assets/photography/13.jpg";
import PoCF_17 from "url:./components/Applications/PhotoGallery/assets/photography/14.jpg";
import PoCF_18 from "url:./components/Applications/PhotoGallery/assets/photography/15.jpg";
import PoCF_19 from "url:./components/Applications/PhotoGallery/assets/photography/16.jpg";
import PoCF_20 from "url:./components/Applications/PhotoGallery/assets/photography/17.jpg";
import PoCF_21 from "url:./components/Applications/PhotoGallery/assets/photography/18.jpg";
import PoCF_22 from "url:./components/Applications/PhotoGallery/assets/photography/19.jpg";
import PoCF_23 from "url:./components/Applications/PhotoGallery/assets/photography/20.jpg";
import PoCF_24 from "url:./components/Applications/PhotoGallery/assets/photography/21.jpg";
import PoCF_25 from "url:./components/Applications/PhotoGallery/assets/photography/22.jpg";
import PoCF_26 from "url:./components/Applications/PhotoGallery/assets/photography/23.jpg";
import PoCF_27 from "url:./components/Applications/PhotoGallery/assets/photography/24.jpg";
import PoCF_28 from "url:./components/Applications/PhotoGallery/assets/photography/25.jpg";
import PoCF_29 from "url:./components/Applications/PhotoGallery/assets/photography/26.jpg";
import PoCF_30 from "url:./components/Applications/PhotoGallery/assets/photography/27.jpg";
import PoCF_31 from "url:./components/Applications/PhotoGallery/assets/photography/28.jpg";
import PoCF_32 from "url:./components/Applications/PhotoGallery/assets/photography/29.jpg";
import PoCF_33 from "url:./components/Applications/PhotoGallery/assets/photography/30.jpg";
import PoCF_34 from "url:./components/Applications/PhotoGallery/assets/photography/31.jpg";
import PoCF_35 from "url:./components/Applications/PhotoGallery/assets/photography/32.jpg";
import PoCF_36 from "url:./components/Applications/PhotoGallery/assets/photography/33.jpg";
import PoCF_37 from "url:./components/Applications/PhotoGallery/assets/photography/34.jpg";
import PoCF_38 from "url:./components/Applications/PhotoGallery/assets/photography/35.jpg";
import PoCF_39 from "url:./components/Applications/PhotoGallery/assets/photography/36.jpg";
import PoCF_40 from "url:./components/Applications/PhotoGallery/assets/photography/37.jpg";
import PoCF_41 from "url:./components/Applications/PhotoGallery/assets/photography/38.jpg";
import PoCF_42 from "url:./components/Applications/PhotoGallery/assets/photography/39.jpg";
import PoCF_43 from "url:./components/Applications/PhotoGallery/assets/photography/40.jpg";
import PoCF_44 from "url:./components/Applications/PhotoGallery/assets/photography/41.jpg";
import PoCF_45 from "url:./components/Applications/PhotoGallery/assets/photography/42.jpg";
import PoCF_46 from "url:./components/Applications/PhotoGallery/assets/photography/43.jpg";
import PoCF_47 from "url:./components/Applications/PhotoGallery/assets/projects/L2_Network_Result.jpg";
import PoCF_48 from "url:./components/Applications/PhotoGallery/assets/projects/L3_Gomoku_3D.png";
import PoCF_49 from "url:./components/Applications/PhotoGallery/assets/projects/L3_IIEST_3D_Discrete.png";
import PoCF_50 from "url:./components/Applications/PhotoGallery/assets/projects/L3_IIEST_Filtre.png";
import PoCF_51 from "url:./components/Applications/PhotoGallery/assets/projects/L3_IIEST_Yolo.png";
import PoCF_52 from "url:./components/Applications/PhotoGallery/assets/projects/M1_IHM_Lando.png";
import PoCF_53 from "url:./components/Applications/PhotoGallery/assets/projects/M1_IHM_Voxelcraft.png";
import PoCF_54 from "url:./components/Applications/PhotoGallery/assets/projects/M1_Internship_GraphPipeline.png";
import PoCF_55 from "url:./components/Applications/PhotoGallery/assets/projects/M1_ReasearchLab_Poster.jpg";
import PoCF_56 from "url:./components/Applications/PhotoGallery/assets/projects/M1_Watermarking_Result.png";
import PoCF_57 from "url:./components/Applications/PhotoGallery/assets/projects/M2_DataVis_Vortexes.jpg";

const PRELOAD_CACHE_FILES = [
    PrCF_1,
    PrCF_2,
    PrCF_3,
    PrCF_4,
    PrCF_5,
    PrCF_6,
    PrCF_7,
    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
    "https://upload.wikimedia.org/wikipedia/commons/8/81/LinkedIn_icon.svg",
    PrCF_8,
    PrCF_9,
];
const POSTLOAD_CACHE_FILES = [
    PoCF_1,
    PoCF_2,
    PoCF_3,
    PoCF_4,
    PoCF_5,
    PoCF_6,
    PoCF_7,
    PoCF_8,
    PoCF_9,
    PoCF_10,
    PoCF_11,
    PoCF_12,
    PoCF_13,
    PoCF_14,
    PoCF_15,
    PoCF_16,
    PoCF_17,
    PoCF_18,
    PoCF_19,
    PoCF_20,
    PoCF_21,
    PoCF_22,
    PoCF_23,
    PoCF_24,
    PoCF_25,
    PoCF_26,
    PoCF_27,
    PoCF_28,
    PoCF_29,
    PoCF_30,
    PoCF_31,
    PoCF_32,
    PoCF_33,
    PoCF_34,
    PoCF_35,
    PoCF_36,
    PoCF_37,
    PoCF_38,
    PoCF_39,
    PoCF_40,
    PoCF_41,
    PoCF_42,
    PoCF_43,
    PoCF_44,
    PoCF_45,
    PoCF_46,
    PoCF_47,
    PoCF_48,
    PoCF_49,
    PoCF_50,
    PoCF_51,
    PoCF_52,
    PoCF_53,
    PoCF_54,
    PoCF_55,
    PoCF_56,
    PoCF_57,
];

let head = document.getElementsByTagName("head")[0];
let link = document.createElement("link");
link.rel = "icon";
link.type = "image/png";
link.href = logo;
head.appendChild(link);

window.mobileAndTabletCheck = function () {
    let check = false;
    (function (a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
                a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        )
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

if (window.mobileAndTabletCheck()) {
    alert("For a better experience, please use a desktop browser.");
}

function preloadInMemory(urls, callback) {
    const cache = {};
    const loads = urls.map((url) =>
        fetch(url)
            .then((res) => {
                if (!res.ok) console.error(`Échec de ${url}: ${res.status}`);
                return res.blob();
            })
            .then((blob) => {
                cache[url] = blob;
            })
    );

    Promise.all(loads)
        .then(() => callback(null, cache))
        .catch((err) => callback(err));
}

let container = document.getElementById("app");
container.innerHTML = "Loading...";

preloadInMemory(PRELOAD_CACHE_FILES, (err, cache) => {
    if (!err) {
        console.log("Tous les fichiers ont été chargés avec succès.");
    } else {
        console.error("Erreur lors du chargement des fichiers:", err);
    }

    container.innerHTML = "";
    let root = createRoot(container);
    root.render(<App />);

    preloadInMemory(POSTLOAD_CACHE_FILES, (err, cache) => {
        if (err) {
            console.error("Erreur lors du chargement des fichiers:", err);
        } else {
            console.log("Tous les fichiers ont été chargés avec succès.");
        }
    });
});
